/* eslint-disable max-len */
export default {
    title: 'Impressum',
    text: [
        'Diese Website ist ein Informationsangebot der Lemlock.',
        '<strong>Anschrift</strong>',
        '<strong>Lemlock</strong>',
        'Bayrische Straße 8<br/> 01069 Dresden',
        'Phone +49 175 689 7058<br/> E-mail: info@lemlock.de',
        'Amtsgericht Dresden HRB 37754<br/> Umsatzsteuer-ID: DE 319124529<br/> Finanzamt: Stuttgart<br/> Geschäftsführer: Jürgen Frücht, Marcin Michalski, Grzegorz Mąkosa'
    ]
};



// WEBPACK FOOTER //
// ./src/i18n/de/legal.js